'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral(['\n\n  ', '\n\n  flex-grow: 2;\n  position: relative;\n\n  span {\n    display: block;\n    font-weight: 500;\n    margin-bottom: 10px;\n  }\n\n  &::after {\n    pointer-events: none;\n    position: absolute;\n    right: 15px;\n    bottom: ', ';\n  }\n'], ['\n\n  ', '\n\n  flex-grow: 2;\n  position: relative;\n\n  span {\n    display: block;\n    font-weight: 500;\n    margin-bottom: 10px;\n  }\n\n  &::after {\n    pointer-events: none;\n    position: absolute;\n    right: 15px;\n    bottom: ', ';\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  ', '\n\n  background-color: ', ';\n  border: 1px solid ', ';\n  box-shadow: ', ';\n  border-radius: 0;\n  font-size: ', ';\n  height: ', ';\n  padding: 10px 40px 10px 15px;\n  width: 100%;\n\n  &:disabled {\n    background-color: ', ';\n    border: 1px solid ', ';\n    box-shadow: none;\n    cursor: default;\n  }\n\n  option:disabled {\n    color: ', ';\n  }\n'], ['\n  ', '\n\n  background-color: ', ';\n  border: 1px solid ', ';\n  box-shadow: ', ';\n  border-radius: 0;\n  font-size: ', ';\n  height: ', ';\n  padding: 10px 40px 10px 15px;\n  width: 100%;\n\n  &:disabled {\n    background-color: ', ';\n    border: 1px solid ', ';\n    box-shadow: none;\n    cursor: default;\n  }\n\n  option:disabled {\n    color: ', ';\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _rem = require('polished/lib/helpers/rem');

var _rem2 = _interopRequireDefault(_rem);

var _config = require('../../config.js');

var _Caret = require('../../mixins/Caret');

var _Caret2 = _interopRequireDefault(_Caret);

var _InputReset = require('../../mixins/InputReset');

var _InputReset2 = _interopRequireDefault(_InputReset);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var caretSettings = {
  position: 'after',
  color: _config.colors.red,
  size: '4px',
  rotating: false,
  initialRotation: '45deg'
};

var SelectWrapper = _styledComponents2.default.div(_templateObject, /* sc-property */(0, _Caret2.default)(caretSettings), function (props) {
  return props.$pointerBottomPosition ? props.$pointerBottomPosition : '17px';
});

SelectWrapper.displayName = 'SelectWrapper';

var StyledSelect = _styledComponents2.default.select(_templateObject2, (0, _InputReset2.default)(), _config.colors.white, function (props) {
  return props.$invalid ? _config.colors.red : _config.colors.gray;
}, function (props) {
  return props.$invalid ? '0 0 0 1px ' + _config.colors.red : 'none';
}, (0, _rem2.default)('16px', _config.typography.baseFontSize), (0, _rem2.default)('40px', _config.typography.baseFontSize), _config.colors.gray, _config.colors.gray, _config.colors.darkGray);

StyledSelect.displayName = 'StyledSelect';

/**
# Button
A basic button.
 */

var Select = function Select(_ref) {
  var _ref$id = _ref.id,
      id = _ref$id === undefined ? '' : _ref$id,
      _ref$label = _ref.label,
      label = _ref$label === undefined ? '' : _ref$label,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === undefined ? function () {
    return undefined;
  } : _ref$onChange,
      _ref$options = _ref.options,
      options = _ref$options === undefined ? [] : _ref$options,
      _ref$value = _ref.value,
      value = _ref$value === undefined ? '' : _ref$value,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === undefined ? false : _ref$disabled,
      _ref$invalid = _ref.invalid,
      invalid = _ref$invalid === undefined ? false : _ref$invalid,
      _ref$pointerBottomPos = _ref.pointerBottomPosition,
      pointerBottomPosition = _ref$pointerBottomPos === undefined ? '' : _ref$pointerBottomPos,
      restProps = _objectWithoutProperties(_ref, ['id', 'label', 'onChange', 'options', 'value', 'disabled', 'invalid', 'pointerBottomPosition']);

  var selectOptions = options.map(function (option) {
    return _react2.default.createElement(
      'option',
      {
        key: option.label,
        disabled: option.disabled,
        value: option.value
      },
      option.label
    );
  });

  return _react2.default.createElement(
    SelectWrapper,
    { $pointerBottomPosition: pointerBottomPosition },
    label && _react2.default.createElement(
      'span',
      null,
      label
    ),
    _react2.default.createElement(
      StyledSelect,
      _extends({
        id: id,
        $invalid: invalid,
        onChange: onChange,
        disabled: disabled,
        value: value
      }, restProps),
      selectOptions
    )
  );
};

Select.propTypes = {
  /** id for the select dropdown */
  id: _propTypes2.default.string,
  /** The label for the Input */
  label: _propTypes2.default.string,
  /** A function to be called when the option is changed */
  onChange: _propTypes2.default.func,
  /** An array of options to populate the select dropdown */
  options: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    label: _propTypes2.default.string.isRequired,
    value: _propTypes2.default.string.isRequired,
    disabled: _propTypes2.default.bool
  })).isRequired,
  /** The currently selected value */
  value: _propTypes2.default.string.isRequired,
  /** Whether the Input is disabled */
  disabled: _propTypes2.default.bool,
  /** Whether the Input is invalid */
  invalid: _propTypes2.default.bool,
  pointerBottomPosition: _propTypes2.default.string
};

Select.displayName = 'Select';

exports.default = Select;
Select.__docgenInfo = {
  'description': '# Button\r\nA basic button.',
  'methods': [],
  'displayName': 'Select',
  'props': {
    'id': {
      'defaultValue': {
        'value': '\'\'',
        'computed': false
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'id for the select dropdown'
    },
    'label': {
      'defaultValue': {
        'value': '\'\'',
        'computed': false
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'The label for the Input'
    },
    'onChange': {
      'defaultValue': {
        'value': '() => undefined',
        'computed': false
      },
      'type': {
        'name': 'func'
      },
      'required': false,
      'description': 'A function to be called when the option is changed'
    },
    'options': {
      'defaultValue': {
        'value': '[]',
        'computed': false
      },
      'type': {
        'name': 'arrayOf',
        'value': {
          'name': 'shape',
          'value': {
            'label': {
              'name': 'string',
              'required': true
            },
            'value': {
              'name': 'string',
              'required': true
            },
            'disabled': {
              'name': 'bool',
              'required': false
            }
          }
        }
      },
      'required': false,
      'description': 'An array of options to populate the select dropdown'
    },
    'value': {
      'defaultValue': {
        'value': '\'\'',
        'computed': false
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'The currently selected value'
    },
    'disabled': {
      'defaultValue': {
        'value': 'false',
        'computed': false
      },
      'type': {
        'name': 'bool'
      },
      'required': false,
      'description': 'Whether the Input is disabled'
    },
    'invalid': {
      'defaultValue': {
        'value': 'false',
        'computed': false
      },
      'type': {
        'name': 'bool'
      },
      'required': false,
      'description': 'Whether the Input is invalid'
    },
    'pointerBottomPosition': {
      'defaultValue': {
        'value': '\'\'',
        'computed': false
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': ''
    }
  }
};